import React, { Component } from "react";
import HeadersAuth from "../Layouts/HeadersAuth";
import { config } from "../_helpers/global";
import axios from "axios";
import $ from "jquery";
import { useHistory } from "react-router-dom";
class RegisterStaff extends Component {
  constructor(props) {
    super(props);

   

    this.state = {
      specialty_description: "",
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      specialty: "",
      password: "",
      tel: "",
      loading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  componentDidMount() {
    document.getElementById("LoadingModal").style.display = "none";
  }

  handleSubmit = (event) => {
    const url = this.api_url+"";
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };
    event.preventDefault();
    // console.log(this.state)
    if (this.state.password !== this.state.password2) {
    } else {
      // console.log(this.state)
      this.setState({ loading: true });
      axios
        .post(this.api_url+"staff/register", this.state, {
          headers: headers,
        })
        .then((response) => {
          this.setState({ loading: false });
          console.log(response.data)

          if (
            response.data["status"] ==
            "Contact Administration for account verification"
          ) {
            $(".alert-success").show();
            // localStorage.setItem('accessToken', response.data['token']);
            setTimeout(function (props) {
              window.location.href = "/";
              // this.props.history.push('/reception/dashboard')
            }, 1000);
            // this.props.history.push('/reception/dashboard')
          } else {
            $("#loginError").fadeIn();
          }
        })
        .catch((error) => {
          $("#loginError").fadeIn();
          this.setState({ loading: false });
          console.log(error);
        });
    }
  };

  componentDidMount() {
    this.setState({
      specialty_description: "Default",
    });

    document.getElementById("LoadingModal").style.display = "none";
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const url = this.api_url+"";
    
    const {
      first_name,
      last_name,
      username,
      email,
      specialty,
      tel,
      password,
      password2,
    } = this.state;
    const loading = this.state.loading;
    return (
      <div>
        <HeadersAuth />

        <main>
          <div className="container p-5">
            <form onSubmit={this.handleSubmit} enctype="multipart/form-data">
              <div className="form-row center">
                <h4 className="text-capitalize">Basic Details</h4>
              </div>
              <div className="form-row pt-2">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      First Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={first_name}
                      name="first_name"
                      type="text"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Last Name
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={last_name}
                      name="last_name"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Username
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={username}
                      name="username"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Profession
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={specialty}
                      name="specialty"
                      required
                    >
                      <optgroup label="Profession">
                        <option selected></option>
                        <option value="doctor">Doctor</option>
                        <option value="nurse">Nurse</option>
                        <option value="receptionist">Receptionist</option>
                        <option value="labtech">Lab Tech</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-row center mt-5">
                <h4 className="text-capitalize">Contact Information</h4>
              </div>
              <div className="form-row pb-4 pt-2">
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Phone Number
                    </h6>
                    <input
                      name="tel"
                      onChange={this.handleChange}
                      value={tel}
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize">Email Address</h6>
                    <input
                      name="email"
                      className="form-control"
                      onChange={this.handleChange}
                      value={email}
                      type="email"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Password
                    </h6>
                    <input
                      name="password"
                      className="form-control"
                      onChange={this.handleChange}
                      value={password}
                      type="password"
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Confirm Password
                    </h6>
                    <input
                      name="password2"
                      className="form-control"
                      onChange={this.handleChange}
                      value={password2}
                      type="password"
                    />
                  </div>
                </div>
              </div>

              <center>
                <div
                  id="loginSuccess"
                  className="alert alert-success"
                  style={displayHidden}
                  role="alert"
                >
                  <strong>Success! </strong>Welcome to Hargeisa OBS. Contact
                  Administrators to get your account approved.
                </div>
                <div className="row">
                  {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                  {/* <div className="col col-12"> */}
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                  >
                    {loading ? <span>Loading...</span> : <span>Submit</span>}
                  </button>
                  {/* </div> */}
                </div>
              </center>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default RegisterStaff;
